import { render } from "./DialogQRAuthBadRequest.vue?vue&type=template&id=0c14406b"
import script from "./DialogQRAuthBadRequest.vue?vue&type=script&lang=js"
export * from "./DialogQRAuthBadRequest.vue?vue&type=script&lang=js"
script.render = render

export default script